import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconService } from '@shared/services/mat-icons.service';
import moment from 'moment';
import { VersionCheckService } from '@shared/services/version-check.service';
import { environment } from '@env/environment';

@Component({
   selector: 'app-root',
   imports: [CommonModule, RouterOutlet],
   templateUrl: './app.component.html',
   styleUrl: './app.component.scss',
})
export class AppComponent {
   constructor(
      @Inject(DOCUMENT) private doc: Document,
      private versionCheckService: VersionCheckService,
      private matIconService: MatIconService // Should stay here to initialise the service!
   ) {
      moment.locale('en', {
         week: {
            dow: 6,
         },
      });

      this.versionCheckService.initVersionCheck();
      this.setupGTAG();
   }

   setupGTAG() {
      if (environment.gaMeasurementId) {
         const script1 = this.doc.createElement('script');
         script1.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaMeasurementId}`;
         script1.async = true;
         this.doc.head.appendChild(script1);

         const script2 = this.doc.createElement('script');
         script2.text = `
           window.dataLayer = window.dataLayer || [];
           function gtag(){ dataLayer.push(arguments); }
           gtag('js', new Date());
           gtag('config', '${environment.gaMeasurementId}');
         `;

         this.doc.head.appendChild(script2);
      }
   }
}
